<template lang="pug">
  .lesson-test-slide
    .lesson-test-slide-controls
      .lesson-test-slide-controls__left
        UploadFile(
          @getFiles="getFile"
          :fileMime="['image/*']"
          :fileExt="[]"
          :buttonClass="data.img && data.img.id ? 'button-primary -disabled-' : 'button-primary'"
          buttonText="Добавить картинку"
          :disabled="data.img && data.img.id"
        )

        File(
          v-if="data.img && data.img.id"
          :file="data.img"
          icon="image"
          @deleteFile="addFileToDelete"
        )

      .lesson-test-slide-controls__right
        Button.-xs-.lesson-test-slide-controls__button(
          @click="$emit('addQuestion')"
        )
          | Добавить вопрос

    Input.lesson-test-slide__input(
      title="Название теста"
      placeholder="Название теста"
      v-model.trim="data.title"
      @input="updateDescription"
    )

    MarkdownText.lesson-test-slide__input.-markdown-.form-item__markdown(
      title="Описание теста"
      v-model="data.description"
      placeholder="Описание теста"
      @input="updateDescription"
    )

</template>

<script>
import _ from 'lodash';
import File from '@/components/File/File';
import UploadFile from '@/components/Form/UploadFiles';
import MarkdownText from '@/components/Form/MarkdownText';

export default {
  components: { File, UploadFile, MarkdownText },
  props: ['propData', 'currentSlideIdx', 'idx'],
  data: () => ({
    data: {
      title: '',
      description: '',
      img: {}
    },
    filesToDelete: [],
    mounted: false
  }),
  watch: {
    currentSlideIdx(val) {
      if (val === this.idx) {
        this.setNavText();
      }
    }
  },
  mounted() {
    this.setData();
  },
  methods: {
    setData() {
      this.data = _.cloneDeep(this.propData);
      this.data = { ...this.data };

      if (this.idx === this.currentSlideIdx) {
        this.setNavText();
      }
    },
    async getFile({ formData }) {
      const res = await this.$store.dispatch('ajax/uploadImage', { formData });
      if (res) {
        this.data.img = { ...res };
      }

      this.updateDescription();
    },
    async addFileToDelete() {
      const files = [
        {
          id: this.data.img.id
        }
      ];
      this.$store.dispatch('coursesLesson/deleteFiles', { files });

      this.data.img = {};

      this.updateDescription();
    },
    setNavText() {
      this.$emit('update:navText', 'Описание');
    },
    updateDescription() {
      this.$emit('updateDescription', this.data);
    }
  }
};
</script>
